export default {"src":"/komodo/_next/static/media/Youtube_Icon.aeda7040.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};